import { useState } from 'react';
import { GOLD, CARD_BG, BORDER, TEXT, MUTED, RED, DARK_BG } from '../constants';

export default function Login({ onSuccess, storedPassword }) {
  const [pw, setPw]     = useState('');
  const [err, setErr]   = useState(false);
  const [show, setShow] = useState(false);

  function handle(e) {
    e.preventDefault();
    if (pw === storedPassword) { onSuccess(); }
    else { setErr(true); setPw(''); }
  }

  return (
    <div style={{ background: DARK_BG, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: CARD_BG, border: `1px solid ${BORDER}`, borderRadius: 16, padding: '56px 64px', width: 420, textAlign: 'center' }}>

        {/* Logo */}
        <div style={{ marginBottom: 40 }}>
          <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 56, fontWeight: 900, color: GOLD, lineHeight: 1, letterSpacing: -2 }}>AGC</div>
          <div style={{ color: MUTED, fontSize: 10, letterSpacing: 4, marginTop: 8 }}>ATLANTA GOLD & COIN</div>
          <div style={{ color: MUTED, fontSize: 9, letterSpacing: 3, marginTop: 4, opacity: 0.6 }}>OPERATIONS DASHBOARD · EST. 2010</div>
        </div>

        <form onSubmit={handle}>
          <div style={{ position: 'relative' }}>
            <input
              type={show ? 'text' : 'password'}
              value={pw}
              onChange={(e) => { setPw(e.target.value); setErr(false); }}
              placeholder="Enter password"
              autoFocus
              style={{
                width: '100%', background: '#0A0C0E', border: `1px solid ${err ? RED : BORDER}`,
                color: TEXT, padding: '13px 44px 13px 16px', borderRadius: 8,
                fontSize: 14, fontFamily: "'DM Mono', monospace", outline: 'none',
                transition: 'border-color 0.2s',
              }}
            />
            <button type="button" onClick={() => setShow(!show)} style={{
              position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', color: MUTED, cursor: 'pointer', fontSize: 14,
            }}>{show ? '🙈' : '👁'}</button>
          </div>

          {err && (
            <div style={{ color: RED, fontSize: 11, marginTop: 8, letterSpacing: 0.5 }}>
              Invalid password. Contact your administrator.
            </div>
          )}

          <button type="submit" style={{
            width: '100%', background: GOLD, color: '#0A0C0E', border: 'none',
            padding: '13px', borderRadius: 8, cursor: 'pointer', fontSize: 13,
            fontWeight: 500, fontFamily: "'DM Mono', monospace", letterSpacing: 1, marginTop: 16,
          }}>Access Dashboard</button>
        </form>

        <div style={{ color: MUTED, fontSize: 9, marginTop: 32, letterSpacing: 1.5, opacity: 0.5 }}>
          SECURED · JOHNS CREEK, GA · PRIVATE ACCESS ONLY
        </div>
      </div>
    </div>
  );
}
